const STORAGE_KEY = 'suppressRecurringModal';
const SOLD_OUT_STORAGE_KEY = 'suppressSoldOutRecurringModal';

/**
 * Checks if the user has opted to suppress the add-to-recurring confirmation modal.
 *
 * @returns {boolean} True if the modal should be suppressed, false otherwise
 */
export const shouldSuppressRecurringModal = () => {
    try {
        return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
};

/**
 * Persists the user's preference to suppress the add-to-recurring confirmation modal.
 *
 * @param {boolean} suppress - Whether to suppress the modal
 */
export const setSuppressRecurringModal = (suppress) => {
    try {
        if (suppress) {
            localStorage.setItem(STORAGE_KEY, 'true');
        } else {
            localStorage.removeItem(STORAGE_KEY);
        }
    } catch {
        // localStorage may not be available in some contexts
    }
};

/**
 * Checks if the user has opted to suppress the sold-out recurring confirmation modal.
 *
 * @returns {boolean} True if the modal should be suppressed, false otherwise
 */
export const shouldSuppressSoldOutRecurringModal = () => {
    try {
        return localStorage.getItem(SOLD_OUT_STORAGE_KEY) === 'true';
    } catch {
        return false;
    }
};

/**
 * Persists the user's preference to suppress the sold-out recurring confirmation modal.
 *
 * @param {boolean} suppress - Whether to suppress the modal
 */
export const setSuppressSoldOutRecurringModal = (suppress) => {
    try {
        if (suppress) {
            localStorage.setItem(SOLD_OUT_STORAGE_KEY, 'true');
        } else {
            localStorage.removeItem(SOLD_OUT_STORAGE_KEY);
        }
    } catch {
        // localStorage may not be available in some contexts
    }
};
